import React from 'react'
import PropTypes from 'prop-types'
import style from './Tabs.less'
import classNames from 'classnames'

const getClass = (index, active) => {
  if (index == active) {
    return classNames([style.tab, style.active])
  }
  return style.tab
}

const Tabs = (props) => (
  <div className={style.main}>
    <div className={style.innerWrapper}>
      {props.tabLabels.map((tabLabel, index) =>
        <div
          key={index}
          className={classNames(getClass(index, props.active))}
          onClick={() => props.onClick(index)}
        >
          <span className={style.label}>{tabLabel}</span>
        </div>
      )}
    </div>
  </div>
)

Tabs.defaultProps = {
  active: 0,
}

Tabs.propTypes = {
  tabLabels: PropTypes.array.isRequired,
  active: PropTypes.number.isRequired,
  onClick: PropTypes.func.isRequired,
}

export default Tabs
